import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
	icons: {
    	iconfont: 'fa',
  	},
  	theme: {
		themes: {
			light: {
				bar: '#2C396E',
				primary: '#2C3977', //'#345995',
				accent: '#FF5A5A', //'#C11D3F', // CLEAR '#FF5A5A', // DARK '#A52541', //,
				secondary: colors.amber.darken1,
				info: '#7498b5', //'#86AAA8',
				warning: colors.pink.darken1,
				error: colors.red.accent4,
				success: colors.green.base,
				cancel: colors.grey.darken1,
				tip: colors.red.darken1,
				//
				bProfile: '#3DC45D',
				bMolecule: '#9129d6',
				bMap: '#00BCD4',
				bTop: '#8BC34A',
				bMapCareer: '#607D8B',
				bTeam: '#2da5e0',
				bArticles: '#EDB529',
				bVideos: '#FC8832',
				bGroup: '#FF52F7',
				bCenter: '#607D8B',
				bAwards: '#9C27B0',
				bSessions: '#795548',
				bCaptains: '#795548',
				bPlanner: '#311B92',
				//
				outsider: '#81CAEF'
			}
		}
	} 
})


